import React from 'react'
import { CreateFormTestContainer } from '../../containers/Officer/CreateFormTestContainer'
export const CreateFormTestPage = () => {
  return (
    <CreateFormTestContainer />
  )
}
